import { useEffect, useState } from 'react';

const navItems = [
  { label: '快速上手', href: '#quickstart' },
  { label: '话题标签', href: '#tags' },
  { label: '使用教程', href: '#tutorials' },
  { label: '常见问题', href: '#faq' },
  { label: '留言反馈', href: '#feedback' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
            <i className="ri-compass-3-line text-xl"></i>
          </span>
          <span className={`font-heading text-xl tracking-wide ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
            黑料导航
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3 py-2 text-sm rounded-md cursor-pointer transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-100/60'
                  : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#quickstart"
            className={`hidden sm:inline-flex items-center gap-1.5 px-4 py-2 text-sm rounded-md cursor-pointer whitespace-nowrap transition-colors ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50 text-foreground-950 hover:bg-primary-100'
            }`}
          >
            <i className="ri-cursor-line"></i>
            开始使用
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer border transition-colors ${
              scrolled
                ? 'border-background-200 text-foreground-800'
                : 'border-background-50/40 text-background-50'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-2 py-3 text-sm text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}